<template>
    <div id="app">
        <h1>{{name}}</h1>
    </div>
</template>


<script>
export default {
    data() {
        return {
            name: "Home"
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue